import { ReactNode } from "react"
import { faLightbulbOn, faSquareDollar } from "@fortawesome/pro-solid-svg-icons"

import WizardCard from "../../components/WizardCard"
import IconText from "../../components/IconText"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export interface GovtWizardSelectApproachCardProps {
  heading: string
  potentialEarnings: string
  impact: string
  children: ReactNode
}

const GovtWizardSelectApproachCard = ({
  heading,
  potentialEarnings,
  impact,
  children,
}: GovtWizardSelectApproachCardProps) => (
  <div>
    <WizardCard paddingSize="sm">
      <div className="flex flex-col gap-3">
        <p className="text-dusk-500 text-sm font-mono font-medium leading-[150%] tracking-[1.68px] uppercase">
          Goal practice stack
        </p>

        <h3 className="text-2xl font-display font-semibold leading-[124%] tracking-[0.48px]">
          {heading}
        </h3>

        <IconText
          icon={faSquareDollar}
          className="text-base text-charcoal-500 font-bold leading-[140%] tracking-[0.32px]"
          iconClass="text-base text-dusk-700 leading-[140%] mr-1"
        >
          Potential earnings: {potentialEarnings}
        </IconText>

        <p className="text-lg font-body leading-[140%] tracking-[0.36px]">
          <strong>Impact:</strong> {impact}
        </p>

        <p className="text-lg font-body leading-[140%] tracking-[0.36px] mt-6">
          Practice stacks you can select:
        </p>

        {children}

        <div className="flex py-4">
          <div className="flex items-center shrink-0 text-leaf px-1">
            <FontAwesomeIcon
              icon={faLightbulbOn}
              title={faLightbulbOn.iconName}
              size="sm"
            />
          </div>

          <p className="font-body leading-[140%] tracking-[0.32px] ml-2">
            <strong>
              Your selected and saved choices will be available to you in your
              saved programs.
            </strong>{" "}
            Dive in deeper and then review options with NRCS representative.
          </p>
        </div>
      </div>
    </WizardCard>
  </div>
)

export default GovtWizardSelectApproachCard
